/* COLD SCHOOL — signup popup. Intelligent timing, cookie suppression, Klaviyo client subscribe. */
(function () {
  'use strict';
  var el = document.querySelector('[data-popup]');
  if (!el) return;

  var COOKIE = 'cs_signup';
  function getCookie(n) { return document.cookie.split('; ').find(function (c) { return c.indexOf(n + '=') === 0; }); }
  function setCookie(n, v, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = n + '=' + v + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  // Already subscribed or dismissed recently → never show
  if (getCookie(COOKIE)) return;
  // Respect logged-in customers (server can add body class) — skip if known
  if (document.body.classList.contains('customer-logged-in')) return;

  var shown = false;
  function open() {
    if (shown || getCookie(COOKIE)) return;
    shown = true;
    el.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('input');
    if (f) f.focus();
    cleanup();
  }
  function close(subscribed) {
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setCookie(COOKIE, subscribed ? 'sub' : 'seen', subscribed ? 400 : 14);
  }

  var delay = (parseInt(el.dataset.delay, 10) || 12) * 1000;
  var scrollPct = parseInt(el.dataset.scroll, 10) || 45;
  var timer = setTimeout(open, delay);

  function onScroll() {
    var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight * 100;
    if (pct >= scrollPct) open();
  }
  function onExit(e) { if (e.clientY <= 0) open(); }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('mouseout', onExit);

  function cleanup() {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
  }

  el.querySelectorAll('[data-popup-close]').forEach(function (b) {
    b.addEventListener('click', function () { close(false); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(false); });

  var form = el.querySelector('[data-popup-form]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = form.email.value.trim();
    var phone = form.phone.value.trim();
    var sms = form.sms_consent.checked;
    var company = el.dataset.company;
    var list = el.dataset.list;

    var done = function () { el.classList.add('is-success'); setCookie(COOKIE, 'sub', 400); };

    // Klaviyo client subscribe (requires company_id + list_id). Falls back gracefully.
    if (company && list && window.fetch) {
      var body = new URLSearchParams();
      body.append('a', company);
      body.append('g', list);
      body.append('email', email);
      if (phone) body.append('phone_number', phone);
      if (sms && phone) body.append('sms_consent', 'true');
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).then(done).catch(done);
    } else {
      // No Klaviyo keys yet — still reveal code; wire keys before launch (see install guide).
      done();
    }
  });
})();
